// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__2TMDy","consentsList":"PatientConsents_consentsList__19BnY","consentsListEmpty":"PatientConsents_consentsListEmpty__EqSvt"};